import {HeaderProps} from "@/elements-react/catalog-layout/header";
import React from "preact/compat";
import styles from "../css/header.module.scss";
import {LayoutStyleTypes} from "@/util-react/layout.tsx";
import {FixBrand} from "@/elements-react/fix-brand";
import {FixLink} from "@/elements-react/fix-link";
import {
    FixDropdownInputCountry,
    FixDropdownInputCurrency,
    FixDropdownInputLanguage
} from "@/elements-react/fix-dropdown-connected";
import B2bButton from "@/elements-react/b2b-button";
import CustomerHead from "@/elements-react/customer-head";
import CartControlDropdown from "@/elements-react/cart-control-dropdown";
import {FixCategoriesButton} from "@/elements-react/fix-categories-button";
import {FixSearch} from "@/elements-react/fix-search";
import classNames from "classnames";
import { Url } from "@/helpers/url";
import {useEffect, useState} from "preact/hooks";
import {useTranslation} from "react-i18next";
import {Gtag} from "@/services/gtag.ts";
import MenuSm from "@/elements-react/menu/MenuSm.tsx";
import {FixButton} from "@/elements-react/fix-button";
import {Icon} from "@/elements-react/fix-icon";
import menuSvg from "@/assets/menu.svg";
import {Input} from "@/uikit";
import {BackShoppingLink} from "@/elements-react/back-shopping-link";
import defaultStyles from "@/elements-react/catalog-layout/header/css/header.module.scss";
import {useServices} from "@/services-context.tsx";

export const HeaderDesktopDefault: React.FC<HeaderProps> = ({ countryElementRefCallback, onCategoryClick, simple }) => {
    return (
        <div className={styles.desktopHead}>
            <div className={styles["head-root"]}>
                <div className={styles["first-row"]}>
                    {
                        simple && <BackShoppingLink />
                    }
                    <div className={classNames(styles.brand, {[styles['centered']]: simple})}>
                        <FixLink href={Url.to("home-page-with-lang")} ariaLabel="logo">
                            <FixBrand type={LayoutStyleTypes.TYPE_LG} />
                        </FixLink>
                    </div>
                    {
                        !simple && (
                            <div className={classNames(styles.controls, styles.center)}>
                                <FixDropdownInputLanguage />
                                <FixDropdownInputCountry ref={countryElementRefCallback} />
                                <FixDropdownInputCurrency />
                            </div>
                        )
                    }
                    {
                        !simple && (
                            <div className={classNames(styles.controls, styles.right)}>
                                <B2bButton />
                                <CustomerHead />
                                <CartControlDropdown />
                            </div>
                        )
                    }
                </div>
                <div className={styles.delimiter}></div>
                {
                    !simple && (
                        <div className={styles["second-row"]}>
                            <div className={styles.categories}>
                                <FixCategoriesButton onClick={onCategoryClick} />
                            </div>
                            <div className={styles.searchline}>
                                <div className={styles.search}>
                                    <FixSearch type={LayoutStyleTypes.TYPE_LG} />
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export const HeaderMobileDefault: React.FC<HeaderProps> = ({ simple }) => {
    const [popup, setPopup] = useState<null | { target: Element }>(null);
    const { router } = useServices();
    const isHomePage = router.isHomePage();
    const { t } = useTranslation();
    const openPopup = (target: Element) => setPopup({ target });
    const closePopup = () => setPopup(null);

    const [searchValue, setSearchValue] = useState<string>(typeof window !== "undefined" ? Url.getQueryParam("q", window.location.search) ?? "" : "");
    const [hasSearched, setHasSearched] = useState(false);

    useEffect(() => {
        if (popup) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }
    }, [popup]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target!.value);
    };

    const search = () => {
        const trimmed = searchValue.trim();
        if (hasSearched || !trimmed) return;
        setHasSearched(true);
        Gtag.pushEvent("search_input", searchValue);
        window.location.href = Url.to("search-page", {}, `?q=${encodeURIComponent(searchValue)}`);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            search();
        }
    };

    const handleBlur = () => {
        search();
    };

    return (
        <div className={classNames(styles.mobileHead, {[styles['simple']]: simple, [styles['home-page']]: isHomePage})}>
            {popup && <MenuSm onClose={closePopup} />}

            <div className={styles["header-root"]}>
                <div className={classNames(styles.brand, {[styles['centered']]: simple})}>
                    <FixLink href={Url.to("home-page-with-lang")} ariaLabel="logo">
                        <FixBrand type={LayoutStyleTypes.TYPE_LG} />
                    </FixLink>
                </div>

                <div className={styles.actions}>
                    <FixButton className={classNames(styles.menu, styles["col-2"])} onClick={(e) => openPopup(e.currentTarget)} variant={'text'} aria-label="Open menu">
                        <Icon width={24} src={menuSvg as string} />
                    </FixButton>

                    { !simple && (
                        <Input
                            name="mpn-search"
                            placeholder={t("kmaqihq7zxarr34z.search-placeholder" as any, "Search for part number" as any)}
                            value={searchValue}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onKeyDown={handleKeyDown}
                            onIconClick={search}
                            icon={<Icon width={16} name="search" />}
                            className={styles.search}
                            inputSize={'small'}
                            iconPosition={'prefix'}
                        />
                    ) }
                    { !simple && <CartControlDropdown />  }
                </div>
            </div>
            {!isHomePage && (
                <div className={defaultStyles.delimiter}></div>
            )}
        </div>
    );
}